module.exports = __webpack_public_path__ + "static/media/7.question.eda0590b.mp4";